export default class Segmentos {
    constructor() {

        this.sections = document.querySelectorAll('.component-segmentos');
        this.ready();
    }

    ready() {

        this.sections.forEach(section => {

            const container = section.querySelector('.container')
            const items = container.querySelectorAll('.itemList')

            container.addEventListener('mouseenter', () => {
                this.actvieFirstItem()
            })
            
        })
        
    }
    
    actvieFirstItem() {
        this.sections.forEach(section => {
            const allActiveItems = section.querySelectorAll('.itemList.active')
            if(allActiveItems.length === 0) {
                section.querySelectorAll('.itemList')[0].classList.add('active');
            }
            this.activeHovers()
        })
    }

    activeHovers() {
        this.sections.forEach(section => {
            const allItems = section.querySelectorAll('.itemList')
            allItems.forEach(item => {
                item.addEventListener('mouseenter', () => {
                    allItems.forEach(subCheck => {
                        subCheck.classList.remove('active')
                    })
                    item.classList.add('active')
                })
            })
        })
    }

}

if (document.querySelector('.component-segmentos')) {
    new Segmentos();
}